<template>
  <div class="modal fade" :id="id" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header modal-header-blue-bg">
          <div class="title-with-icon">
            <div class="title-with-icon__icon title-with-icon__icon-white title-with-icon__icon_exclamation"></div>
            <div class="title-with-icon__title">{{ title }}</div>
          </div>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="submitForm" class="needs-validation" :class="{'was-validated': formSubmitted}" novalidate>
            <div class="mb-3 row">
              <div class="col-md-6">
                <div>
                  <input 
                    v-model="formData.lastname" 
                    :class="{invalid: errors.has('lastname')}" 
                    v-validate.immediate="{ required: true }" 
                    name="lastname" 
                    type="text" 
                    class="form-control" 
                    placeholder="Фамилия" 
                    :disabled="$authCheck() && formData.lastname"
                    required
                  />
                  <div v-if="errors.has('lastname')" class="invalid-feedback d-block">
                    {{ errors.first('lastname') }}
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div>
                  <input 
                    v-model="formData.firstname" 
                    :class="{invalid: errors.has('firstname')}" 
                    v-validate.immediate="{ required: true }" 
                    name="firstname" 
                    type="text" 
                    class="form-control" 
                    placeholder="Имя" 
                    :disabled="$authCheck() && formData.firstname"
                    required
                  />
                </div>
              </div>
            </div>
            
            <div class="mb-3 row">
              <div class="col-md-6">
                <div>
                  <input 
                    v-model="formData.middlename" 
                    name="middlename" 
                    type="text" 
                    class="form-control" 
                    placeholder="Отчество"
                    :disabled="$authCheck() && formData.middlename"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div>
                  <input 
                    v-model="formData.email" 
                    :class="{invalid: errors.has('email')}" 
                    v-validate.immediate="'required|email'" 
                    type="email" 
                    name="email" 
                    class="form-control" 
                    placeholder="E-mail" 
                    :disabled="$authCheck() && formData.email"
                    required
                  />
                </div>
              </div>
            </div>

            <div class="mb-3 row">
              <div class="col-md-6">
                <div>
                  <input 
                    v-model="formData.institution" 
                    :class="{invalid: errors.has('institution')}" 
                    v-validate.immediate="{ required: true }" 
                    name="institution" 
                    type="text" 
                    class="form-control" 
                    :placeholder="isJunior ? 'Школа' : 'Вуз или компания'"
                    required
                  />
                </div>
              </div>
              <div class="col-md-6">
                <select
                    v-if="isJunior"
                    v-model="formData.course"
                    :class="{invalid: errors.has('course')}"
                    v-validate.immediate="{ required: true }"
                    name="course"
                    class="form-control"
                    required
                >
                  <option value="">Выберите класс</option>
                  <option v-for="grade in grades" :key="grade" :value="grade">{{ grade }}</option>
                </select>
                <input
                    v-else
                    v-model="formData.course"
                    :class="{invalid: errors.has('course')}"
                    v-validate.immediate="{ required: true }"
                    name="course"
                    type="text"
                    class="form-control"
                    placeholder="Курс или должность"
                    required
                />
              </div>
            </div>

            <div class="mb-3 row">
              <div class="col-12">
                 <autocomplete
                     v-model="formData.city"
                     :class="{invalid: !formData.city && formSubmitted}"
                     placeholder="Выберите город"
                     :disabled="$authCheck() && formData.city"
                     valueName="city_name_ru"
                 />
              </div>
            </div>

            <!-- Поля пароля для неавторизованных пользователей -->
            <div v-if="!$authCheck()" class="mb-3 row">
              <div class="col-md-6">
                <input v-model="formData.password" :class="{'invalid': errors.has('password')}" name="password" v-validate.immediate="'required|min:6'" type="password" ref="password" class="form-control" id="form-pass-1" placeholder="Введите пароль" required />
              </div>
              <div class="col-md-6">
                <input v-model="formData.passwordConfirmation" :class="{'invalid': errors.has('password_confirmation')}" name="password_confirmation" v-validate.immediate="'required|min:6|confirmed:password'" type="password" class="form-control" id="form-pass-2" placeholder="Повторите пароль" required/>
              </div>
            </div>

            <div v-if="!$authCheck()" class="mb-3">
              <div class="form-description">
                Пароль должен содержать латинские буквы и цифры, а длина пароля — <strong class="content_700">не менее 6 знаков</strong>.
              </div>
            </div>

            <base-upload v-if="isJunior" v-model="consent" :required="true" :id="id + '-consent'" name="parent_consent"
                         title="Согласие родителя на обработку персональных данных"
                         description="<span class='text-red'>Чтобы мы могли принять заявку школьника, нужно согласие родителя (законного представителя). Скачайте бланк, заполните его, подпишите и загрузите скан или фото: PDF, JPG или PNG, не больше 10 МБ</span>"
                         :sample="{title: 'Бланк согласия родителя', link: consentBlankUrl}"
                         :accept="consentAccept" :deferred="true" :max-size="consentMaxSize" :notify-on-error="true" />

            <div class="mb-3">
              <registration-form-condition v-model="agree">
                Я ознакомлен(а) с <a target="_blank" rel="noopener" :href="reglamentUrl">Регламентом Олимпиады</a>, даю <a target="_blank" rel="noopener" :href="pdConsentUrl">согласие на обработку персональных данных</a>.
              </registration-form-condition>
              <div v-if="formSubmitted && !agree" class="invalid-feedback d-block">Подтвердите согласие с условиями</div>
            </div>

            <div v-if="$authCheck()" class="mb-3">
              <small class="text-success">
                <i class="fas fa-info-circle"></i> 
                ФИО и email заполнены автоматически из вашего профиля и заблокированы для редактирования
              </small>
            </div>

            <div v-if="registerError" class="alert alert-danger mb-3">
              {{ registerError }}
            </div>
          </form>
        </div>
        <div class="modal-footer d-flex justify-content-between">
          <button type="button" class="btn btn-md btn-secondary" @click="cancel">Отмена</button>
          <button type="button" class="btn btn-md btn-primary" @click="submitForm" :disabled="loading">
            Зарегистрироваться
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import ApiService from "../../../services/api.service";
import {TokenService} from "../../../services/token.service";
import Autocomplete from "../Autocomplete.vue";
import RegistrationFormCondition from "@/components/register/RegistrationFormCondition.vue";
import BaseUpload from "@/components/form/BaseUpload.vue";
window.jQuery = $

export default {
  name: "OlympicsRegistrationForm",
  props: {
    id: {
      type: String,
      default: 'olympics-registration-form'
    },
    value: {
      type: Boolean,
      required: true
    },
    // Трек, выбранный кнопкой на лендинге: junior или pro
    track: {
      type: String,
      default: null
    },
    consentBlankUrl: {
      type: String,
      required: true
    },
    reglamentUrl: {
      type: String,
      required: true
    },
    pdConsentUrl: {
      type: String,
      required: true
    }
  },
  components: {
    Autocomplete,
    RegistrationFormCondition,
    BaseUpload
  },
  data() {
    return {
      formData: {
        track: null,
        lastname: '',
        firstname: '',
        middlename: '',
        email: '',
        institution: '',
        course: '',
        city: null,
        password: '',
        passwordConfirmation: ''
      },
      grades: ['8 класс', '9 класс', '10 класс', '11 класс'],
      consent: null,
      consentAccept: '.pdf, .jpg, .jpeg, .png, application/pdf, image/jpeg, image/png',
      consentMaxSize: 10 * 1024 * 1024,
      agree: false,
      formSubmitted: false,
      registerError: false,
      loading: false,
      isCancelModalOpen: false
    }
  },
  mounted() {
    let self = this
    $('#' + this.id).on('hide.bs.modal', function () {
      // Не закрываем модальное окно, если открывается модальное окно подтверждения отмены
      if (self.isCancelModalOpen) {
        return;
      }
      self.$emit('input', false)
    })
    
    // Обработчик для установки z-index backdrop при показе основного модального окна
    $('#' + this.id).on('shown.bs.modal', function () {
      // Подсчитываем количество backdrop'ов
      const backdropCount = $('.modal-backdrop').length;
      
      if (backdropCount === 1) {
        // Если backdrop один - z-index: 1040
        $('.modal-backdrop').attr('style', 'z-index: 1040 !important;');
      }
    })
    
    // Обработчик для сброса флага при закрытии модального окна подтверждения отмены
    $(document).on('hidden.bs.modal', '#olympics-cancel-confirm-modal', function () {
      self.isCancelModalOpen = false
    })
    
    // Добавляем кастомные сообщения валидации
    this.$validator.localize('ru', {
      messages: {
        ru: {
          required: (field) => `Поле ${field} обязательно для заполнения`,
          email: 'Введите корректный email адрес',
          confirmed: 'Пароли не совпадают'
        }
      },
      attributes: {
        lastname: 'Фамилия',
        firstname: 'Имя',
        email: 'Email',
        institution: 'Название учебного заведения',
        course: 'Курс',
        city: 'Город',
        password: 'Пароль',
        passwordConfirmation: 'Подтверждение пароля'
      }
    })
  },
  computed: {
    isJunior() {
      return this.formData.track === 'junior'
    },
    // Трек выбран кнопкой на лендинге и в форме не меняется
    title() {
      if (this.formData.track === 'junior') {
        return 'Регистрация на трек «Старт»'
      }
      if (this.formData.track === 'pro') {
        return 'Регистрация на трек «Профи»'
      }
      return 'Регистрация на олимпиаду'
    }
  },
  watch: {
    value: {
      handler: async function(val) {
        $('#' + this.id).modal(val ? 'show' : 'hide');
        if (val) {
          this.resetForm()
        }
      }
    }
  },
  methods: {
    fillUserData() {
      const user = TokenService.getUserObj()
      if (user) {
        this.formData = {
          track: this.track,
          lastname: user.lastname || '',
          firstname: user.firstname || '',
          middlename: user.middlename || '',
          email: user.email || '',
          institution: user.organization?.name || '',
          course: '',
          city: user.city || null,
          password: '',
          passwordConfirmation: ''
        }
      }
    },
    resetForm() {
      // Заполняем данные пользователя, если он авторизован
      if (this.$authCheck()) {
        this.fillUserData()
      } else {
        this.formData = {
          track: this.track,
          lastname: '',
          firstname: '',
          middlename: '',
          email: '',
          institution: '',
          course: '',
          city: null,
          password: '',
          passwordConfirmation: ''
        }
      }
      this.consent = null
      this.agree = false
      this.formSubmitted = false
      this.registerError = false
      this.loading = false
      this.$validator.reset()
    },
    cancel() {
      // Устанавливаем флаг, что открывается модальное окно подтверждения отмены
      this.isCancelModalOpen = true
      // Сбрасываем форму
      this.resetForm()
      // Только эмитим событие, не закрываем модальное окно напрямую
      this.$emit('cancel')
    },
    async submitForm() {
      this.formSubmitted = true
      this.registerError = false

      let result = await this.$validator.validateAll()

      // Город проверяем отдельно, так как Autocomplete может не работать с VeeValidate
      if (!result || !this.formData.city) {
        this.registerError = 'Проверьте правильность ввода полей формы'
        return;
      }

      if (!this.agree) {
        this.registerError = 'Подтвердите, что ознакомились с Регламентом и согласны на обработку персональных данных'
        return;
      }

      this.loading = true

      try {
        // Подготавливаем данные для отправки
        const registrationData = { ...this.formData }
        
        // Обрабатываем город - если это объект, берем ID
        if (registrationData.city && typeof registrationData.city === 'object') {
          registrationData.city = registrationData.city.id
        }
        
        // Если пользователь авторизован, убираем пароли из данных
        if (this.$authCheck()) {
          delete registrationData.password
          delete registrationData.passwordConfirmation
        }

        // Отправляем multipart: у школьников вместе с формой уходит скан согласия родителя
        const data = new FormData()
        Object.keys(registrationData).forEach((key) => {
          if (registrationData[key] !== null && registrationData[key] !== undefined) {
            data.append(key, registrationData[key])
          }
        })
        if (this.isJunior) {
          data.append('consent', this.consent, this.consent.name)
        }

        const response = await ApiService.registerForOlympics(data)
        
        if (response.status === 200) {
          this.$emit('success', this.formData)
          this.$emit('input', false)
        } else {
          this.registerError = response.data?.message || 'Произошла ошибка при регистрации'
        }
      } catch (error) {
        this.registerError = error.response?.data?.errors?.errors?.[0] || error.response?.data?.message || 'Произошла ошибка при регистрации'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.modal-dialog {
  max-height: 90vh;
  margin: 1.75rem auto;
  z-index: 1050;
}

.modal-content {
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.modal-body {
  padding: 2rem 4rem;
  max-height: calc(90vh - 120px);
  overflow-y: auto;
  flex: 1;
}

.modal-header {
  flex-shrink: 0;
}

.modal-footer {
  flex-shrink: 0;
  padding: 1rem 2rem;
  border-top: 1px solid #dee2e6;
  background-color: #f8f9fa;
}

// Стили для модального окна подтверждения
.modal-backdrop {
  z-index: 1040;
}

.modal.show {
  z-index: 1050;
}

// Убеждаемся, что модальное окно подтверждения отображается поверх основного
.modal.fade .modal-dialog {
  z-index: 1055;
}

@media (max-width: 768px) {
  .modal-dialog {
    margin: 0.5rem;
    max-height: 95vh;
  }
  
  .modal-content {
    max-height: 95vh;
  }
  
  .modal-body {
    padding: 1rem 2rem;
    max-height: calc(95vh - 120px);
  }
  
  .modal-footer {
    padding: 0.75rem 1rem;
  }
  
  .grid-2 {
    grid-template-columns: 1fr;
  }
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545;
}

.was-validated .form-control:invalid ~ .invalid-feedback,
.form-control.is-invalid ~ .invalid-feedback {
  display: block;
}

.form-control.invalid {
  border-color: #dc3545;
}

/* Стили для заблокированных полей */
.form-control:disabled {
  background-color: #f8f9fa;
  opacity: 0.7;
  cursor: not-allowed;
}

</style>

<style lang="scss">
// Глобальные стили для исправления z-index модальных окон
.modal-backdrop {
  z-index: 1040 !important;
}

.modal {
  z-index: 1050 !important;
}

.modal.show {
  z-index: 1050 !important;
}

.modal.fade .modal-dialog {
  z-index: 1055 !important;
}

// Убеждаемся, что модальное окно подтверждения отображается поверх основного
.modal-dialog {
  z-index: 1055 !important;
}

// Убираем все CSS стили для backdrop - управляем только через JS

// Невидимый input чекбокса растянут на всю подпись и перекрывает ссылки на соглашения: оставляем его только над квадратом
#olympics-registration-form .checkbox input {
  width: 2.4rem !important;
}

// Стили для модального окна подтверждения отмены
#olympics-cancel-confirm-modal {
  z-index: 1060 !important;
}

#olympics-cancel-confirm-modal .modal-dialog {
  z-index: 1060 !important;
}

#olympics-cancel-confirm-modal .modal-content {
  z-index: 1060 !important;
}
</style>
